module.exports = __webpack_public_path__ + "static/media/favicon-logo.9b6ee95f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon-logo.jpg
// module id = 511
// module chunks = 0